<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="maxWidth"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
    class="confirm-dialog"
  >
    <v-card>
      <v-card-title class="headline confirm-dialog__title">{{
        title
      }}</v-card-title>
      <v-card-text v-if="description">{{ description }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          rounded
          text
          :color="color"
          elevation="0"
          :disabled="cancelDisabled"
          :loading="loadingButtons"
          @click="cancel"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          rounded
          :class="submitBtnClass"
          :color="color"
          elevation="0"
          :disabled="submitDisabled"
          :loading="loadingButtons"
          @click="submit"
        >
          {{ submitText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    submitText: {
      type: String,
      default: 'Submit',
    },
    cancelDisabled: {
      type: Boolean,
      default: false,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 290,
    },
    color: {
      type: String,
      default: 'primary',
    },
    submitBtnClass: {
      type: String,
      default: '',
    },
    loadingButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
      }
    },
  },
  methods: {
    submit() {
      this.dialog = false
      this.$emit('submit')
    },
    cancel() {
      this.dialog = false
      this.$emit('cancel')
    },
    onClickOutside() {
      this.cancel()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.cancel()
    },
  },
}
</script>

<style lang="scss">
.confirm-dialog {
  &__title {
    word-break: normal;
  }
}
</style>
